module.exports = __webpack_public_path__ + "img/icon_equipe.bdfb5403.png";